import { BaseEntity, Column, Entity, Index, JoinColumn, JoinTable, ManyToMany, ManyToOne, OneToMany, OneToOne, PrimaryColumn, PrimaryGeneratedColumn, RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn } from "typeorm";

@Entity('soack_styles')
export class SoakStyleEntity {

  @PrimaryGeneratedColumn("increment",
   { name: 'soack_style_id' })
  soakstyleId: number;


  @Column("varchar", {
    nullable: false,
    length: 40,
    name: "soack_style"
  })
  soakstyle: string;

@Column("varchar", {
    nullable: true,
    name: "created_user"
  })
  createdUser: string | null;
 
  @CreateDateColumn({
    name: "created_at",
    type: "datetime"
  })
  createdAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "updated_user"
  })
  updatedUser: string | null;


  @UpdateDateColumn({
    name: "updated_at",
    type: 'datetime'
  })
  updatedAt: Date;

 @VersionColumn({
    default: 1,
    name: "version_flag"
  })
  versionFlag: number;

  @Column("boolean",{
    nullable:false,
    default:true,
    name:"is_active"
})
isActive:boolean;

}